import { ShoppingCartItem } from "components/ShoppingCart";
import { ShopItemDetails } from "./ShopItemView.types";

/**
 * Creates a ShoppingCartItem with the specified quantity from shop item data
 */
export const createCartItemFromShopData = (
  selectedItem: ShoppingCartItem,
  shopItemData: ShopItemDetails | undefined,
  quantity: number
): ShoppingCartItem => {
  return {
    ...selectedItem,
    quantity,
    // Override with API data if available
    name: shopItemData?.name || selectedItem.name,
    itemCode: shopItemData?.code || selectedItem.itemCode,
    itemDescription: shopItemData?.detailedDescription || selectedItem.itemDescription,
    price: shopItemData?.price || selectedItem.price,
  };
};

/**
 * Gets the display name for an item, preferring API data over fallback data
 */
export const getDisplayName = (
  shopItemData: ShopItemDetails | undefined,
  fallbackItem: ShoppingCartItem
): string => {
  return shopItemData?.name || fallbackItem.name;
};

/**
 * Gets the display code for an item, preferring API data over fallback data
 */
export const getDisplayCode = (
  shopItemData: ShopItemDetails | undefined,
  fallbackItem: ShoppingCartItem
): string => {
  return shopItemData?.code || fallbackItem.itemCode;
};

/**
 * Gets the display description for an item, preferring API data over fallback data
 */
export const getDisplayDescription = (
  shopItemData: ShopItemDetails | undefined,
  fallbackItem: ShoppingCartItem
): string => {
  return shopItemData?.detailedDescription || fallbackItem.itemDescription;
};

/**
 * Gets the display delivery time for an item, with fallback
 */
export const getDisplayDeliveryTime = (
  shopItemData: ShopItemDetails | undefined,
  fallback = "1-2 weeks"
): string => {
  return shopItemData?.estimatedDeliveryTime || fallback;
};

/**
 * Gets the display price for an item, preferring API data over fallback data
 */
export const getDisplayPrice = (
  shopItemData: ShopItemDetails | undefined,
  fallbackItem: ShoppingCartItem
): number => {
  return shopItemData?.price || fallbackItem.price;
};

/**
 * Determines which image to display, preferring API data over fallback data
 */
export const getImageProps = (
  shopItemData: ShopItemDetails | undefined,
  fallbackItem: ShoppingCartItem
): {
  src?: string;
  alt: string;
} => {
  if (shopItemData?.filePath) {
    return {
      src: shopItemData.filePath,
      alt: shopItemData.name,
    };
  }

  if (fallbackItem.itemImageUrl) {
    return {
      src: fallbackItem.itemImageUrl,
      alt: fallbackItem.name,
    };
  }

  return {
    alt: fallbackItem.name,
  };
};
